import { Component } from 'react';
import { Field } from 'redux-form';
import { SelectField } from './SelectField';
import { IwDynamicFormattedMessage } from '../../../../iwDynamicFormattedMessage/IwDynamicFormattedMessage';

export class Select extends Component {
    handleOptionAndValueRenderer = ({ value, label }) => {
        return (
            <IwDynamicFormattedMessage
                messages={this.props.messages}
                messageKey={value}
                defaultMessage={label}
            />
        );
    };

    renderSelect = () => {
        // eslint-disable-next-line react/display-name
        return (props) => (
            <SelectField
                id={this.props.name}
                optionRenderer={this.handleOptionAndValueRenderer}
                options={this.props.options}
                className={this.props.className}
                label={this.props.label}
                name={this.props.name}
                data-testid={this.props['data-testid']}
                placeholder={this.props.placeholder}
                meta={props.meta}
                input={props.input}
            />
        );
    };

    render() {
        return (
            <Field
                className={this.props.className}
                label={this.props.label}
                name={this.props.name}
                component={this.renderSelect()}
                data-testid={this.props['data-testid']}
                placeholder={this.props.placeholder}
            />
        );
    }
}
